/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { IntlService } from "ember-intl";
import Protocol from "parog-web/models/protocol";
import { updateFollowingCureDate } from "../../utils/protocol-helpers";
import type { ProtocolSectionArgs } from "../base-protocol-item";

interface Args extends ProtocolSectionArgs {
  numberOfCure: number;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
  Blocks: {
    beforeContent: [];
  };
}

export default class TreatmentHistoryEditionFormUtilsProtocolWithCureItemComponent extends Component<Signature> {
  @service declare intl: IntlService;

  get protocolModel(): Protocol {
    return Protocol.new(this.args.changeset.data);
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset, propertyName: string) {
    updateFollowingCureDate({
      changeset,
      propertyName,
      timeValue: 3,
      timeUnit: "weeks",
      numberOfCures: this.args.numberOfCure
    });

    if (!this.protocolModel.isPaused) {
      this.args.changeset.set("pause-date", null);
      this.args.changeset.set("pause-time-frequency-value", null);
      this.args.changeset.set("pause-time-frequency-unit", null);
    }

    this.args.onChangesetUpdate(changeset);
  }

  get allCureIndexes(): number[] {
    return Array.from(
      { length: this.args.numberOfCure },
      (_, index) => index + 1
    );
  }
}
